<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import SurrenderForm from './SurrenderForm.vue'

export default {
  components: { SurrenderForm, ButtonAll, ModalDialog },
  mixins: [mixinComponent],

  props: {
    financeId: { type: Number, required: true },
    surrenderId: { type: Number, default: null, required: false },
    method: { type: String, required: false },
    idModalPage: { type: String, default: '' },
    profitability: { type: Boolean, default: false },
  },

  data() {
    return {
      loadForm: false,
    }
  },

  computed: {
    modalId() {
      return 'surrender' + this.surrenderId ?? this.financeId
    },
    isDeleteMethod() {
      return this.method === 'delete'
    },
  },

  methods: {
    async showForm() {
      if (!this.isDeleteMethod) {
        this.openModal()
      } else {
        await this.deleteSurrender()
      }
    },
    openModal() {
      this.loadForm = true
      this.$refs[this.modalId].open()
    },
    closeModal() {
      this.loadForm = false
      this.$refs[this.modalId].close(false)
    },
    onSurrendersSent(surrender) {
      this.$emit('surrenders-sent', surrender)
      this.closeModal()
    },
    async deleteSurrender() {
      let response = await this.deleteJSON(`surrenders/${this.surrenderId}`, { financeId: this.financeId }, {})

      if (response) {
        this.$emit('surrenders-sent', { json: { id: this.surrenderId }, method: 'delete' })
      }
    },
  },
}
</script>
<template>
  <div class="surrender-form">
    <a class="cursor-pointer" role="button" @click="showForm">
      <template v-if="profitability">
        <i class="fa fa-plus" e2e-input="surrenderAdd"></i>
      </template>
      <template v-else>
        <i v-if="method === 'post'" class="fa fa-plus" e2e-input="surrenderAdd"></i>
        <i v-else-if="method === 'patch'" class="fa fa-edit" e2e-input="surrenderUpdate"></i>
        <i v-else class="fas fa-trash" e2e-input="surrenderDelete"></i>
      </template>
    </a>

    <ModalDialog
      v-if="!isDeleteMethod"
      :id-modal-page="idModalPage"
      :id="modalId"
      :ref="modalId"
      class-modal-dialog="modal-xl"
      @icon-close="closeModal"
      e2e-modal="surrender"
    >
      <SurrenderForm
        v-if="loadForm"
        :surrender-id="surrenderId"
        :finance-id="financeId"
        :entity-id="entityId"
        :method="method"
        @surrenders-sent="onSurrendersSent"
      >
        <template #buttons>
          <ButtonAll
            margin="no"
            data-dismiss="modal"
            type="information"
            label="button.close"
            @click="closeModal"
            e2e-input="close"
          />
        </template>
      </SurrenderForm>
    </ModalDialog>
  </div>
</template>
